// extracted by mini-css-extract-plugin
module.exports = {"maincontent":"services-module--maincontent--Ye0Nz","mainimg":"services-module--mainimg--3cAuJ","mainlink":"services-module--mainlink--2M7p6"};